import { render, staticRenderFns } from "./Gdtv3TargetingAdd.vue?vue&type=template&id=49aa2e74&scoped=true"
import script from "./Gdtv3TargetingAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./Gdtv3TargetingAdd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Gdtv3TargetingAdd.vue?vue&type=style&index=0&id=49aa2e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa2e74",
  null
  
)

export default component.exports